const apiPaths = {
    detectLang: "detect",
    languagesList: "languages",
    translate: "translate",
};

export default apiPaths;
